/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Finance_Settings_TitleInputs */

const en_finance_settings_title = /** @type {(inputs: Finance_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payments setup`)
};

const pl_finance_settings_title = /** @type {(inputs: Finance_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ustawienia płatności`)
};

/**
* | output |
* | --- |
* | "Payments setup" |
*
* @param {Finance_Settings_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const finance_settings_title = /** @type {((inputs?: Finance_Settings_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Finance_Settings_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_finance_settings_title(inputs)
	return en_finance_settings_title(inputs)
});